/**
 * @description
 */

import './sectionRadioboxList.scss';

import React from 'react';

import FormRadioboxList, { IProps, IState } from '../@formRadioboxList/formRadioboxList';
import {
    ESectionValid,
    ESectionType,
    ISectionOptionBaseInfo,
    ISectionBaseExtend,
    ISectionBaseSetup,
    ISectionBaseInfo,
    ISectionBaseResult,
} from '@umu/umu-types';

// 这里提供最基础的问卷功能和结构，后续可扩展这个业务基类。
// 但比如考试的问卷与业务强相关，通过继承FormRadioboxList实现一个新组件去做
// tslint:disable-next-line:max-line-length
export default abstract class SectionRadioboxList extends FormRadioboxList<
    IProps<ESectionType, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
    IState
> {
    public abstract getExtraOptionId(
        section: ISectionBaseInfo<any, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
    ): number;
    public abstract validSection(
        section: ISectionBaseInfo<any, ISectionOptionBaseInfo, ISectionBaseExtend<ISectionBaseSetup>>,
        result: ISectionBaseResult<any>,
    ): ESectionValid;

    public render() {
        return <div className="section-item-body">{super.render()}</div>;
    }
}
